<script lang="ts">
  let { className = '' }: { className?: string } = $props();
</script>

<div class="animate-pulse bg-bg-hover rounded {className}"></div>
